import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetPartnersQuery = () => {
  const { getPartners } = useServicesContext();

  return useQuery({
    queryKey: ['GET_PARTNERS'],
    queryFn: getPartners,
  });
};
